import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Row, Col } from 'react-bootstrap';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import Sidebar from './Sidebar';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import {
  getRoleNames,
  getOwnershipTypeName,
  getMemberByUserId,
  getWorkTypeNameById,
  getSubscriptionType,
} from '../../utils';
import ShortContent from '../ContractBlock/ShortContent';

class CreateReview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      comments: '',
    };
  }

  componentWillMount() {
    const { team, agreement } = this.props;

    if (team) {
      this.props.loadMembers(team.id);
    }
    if (agreement && agreement.id) {
      this.props.loadBlockContents(agreement.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { status, agreement, dealStatus, deal, workStatus, work, invites } =
      nextProps;

    if (this.props.status === actionTypes.AGREEMENT_CREATE_REQUEST) {
      if (status === actionTypes.AGREEMENT_CREATE_SUCCESS && agreement) {
        this.saveContractBlocks(agreement);
        this.createWork(agreement.id);
      } else if (status === actionTypes.AGREEMENT_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    } else if (this.props.workStatus === actionTypes.WORK_CREATE_REQUEST) {
      if (workStatus === actionTypes.WORK_CREATE_SUCCESS && work && agreement) {
        this.createDeal(agreement, work);
        this.createWorkOwnerships(work);
      } else if (workStatus === actionTypes.WORK_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    } else if (this.props.dealStatus === actionTypes.DEAL_CREATE_REQUEST) {
      if (dealStatus === actionTypes.DEAL_CREATE_SUCCESS && deal) {
        this.createInvites(deal);
      } else if (dealStatus === actionTypes.DEAL_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    } else if (
      this.props.invites.status === actionTypes.INVITE_CREATE_REQUEST
    ) {
      if (invites.status === actionTypes.INVITE_CREATE_SUCCESS) {
        this.props.alert('success', 'Your agreement has been sent!');
        this.props.router.push('/');
      }
    }
  }

  handleSave() {
    const { agreement, contractBlocks, profile, subscription } = this.props;

    this.props.hideAlert();

    // Move to payment page to buy 1 Single Agreement
    const { planType } = getSubscriptionType(
      profile.subscription_plan,
      subscription
    );

    if (agreement.type !== 'split') {
      const isPremiumExpired =
        profile.subscription_plan === 'premium' &&
        profile.trial_expired === true;

      if (
        isPremiumExpired ||
        (planType !== 'premium' &&
          planType !== 'essential' &&
          planType !== 'pro')
      ) {
        const teamMessage = this.state.comments;
        this.props.assignAttribute('teamMessage', teamMessage);
        this.props.router.push('/create/agreement/payment');
        return;
      }
    }

    if (agreement && agreement.id) {
      // Creat work from original agreement
      this.createWork(agreement.id, true);
    } else {
      // Create new agreements
      const comments = this.state.comments;
      let licenserIds = [];
      const block = R.find(R.propEq('name', 'Licensing Permissions'))(
        contractBlocks
      );

      if (block && block.options) {
        licenserIds = block.options.licenserIds || [];
      }

      this.props.createAgreement({
        ...agreement,
        licenser_ids: licenserIds,
        comments,
      });
    }
  }

  createWork(agreementId, additional = false) {
    const { fields, profile, team } = this.props;

    const data = {
      name: fields.name,
      type: fields.type,
      sub_type: fields.subtype,
      user: profile.id,
      agreement: agreementId,
      team: team.id,
      additional: additional,
      sound_recording_type: fields.soundRecordingType,
    };

    this.props.createWork(data);
  }

  saveContractBlocks(agreement) {
    const { agreementContractBlocks } = this.props;

    agreementContractBlocks.forEach((block) => {
      this.props.saveBlockContent({
        ...block,
        agreement: agreement.id,
      });
    });
  }

  createDeal(agreement, work) {
    const { team, profile } = this.props;

    const data = {
      team: team.id,
      user: profile.id,
      agreement: agreement.id,
      work: work.id,
    };

    this.props.createDeal(data);
  }

  createWorkOwnerships(work) {
    const { workOwnerships, members } = this.props;

    workOwnerships.forEach((ownership) => {
      let data = {
        work: work.id,
        ...ownership,
      };

      const member = getMemberByUserId(ownership.user, members);
      if (member && member.user_info) {
        data = {
          ...data,
          use_company_name: member.user_info.use_company_name,
          company_name: member.user_info.company_name,
          user_title: member.user_info.user_title,
          ...member.user_info,
        };
      }

      this.props.createWorkOwnership(data);
    });
  }

  getPubishable() {
    const { workTypes, fields, agreement } = this.props;

    if (
      agreement &&
      agreement.type !== 'workforhire' &&
      agreement.type !== 'producer'
    ) {
      if (fields.type) {
        const workTypeName = getWorkTypeNameById(fields.type, workTypes);
        return workTypeName === 'Music';
      }
    }

    return false;
  }

  createInvites(deal) {
    const { members, profile, fields } = this.props;

    const data = {
      deal: deal.id,
      inviter: profile.id,
      inviter_name: profile.name,
      type: 'member',
      comment: this.state.comments,
    };

    let inviteData = [];
    members.forEach((member) => {
      inviteData = [
        ...inviteData,
        {
          ...data,
          invitee: member.user,
          email: member.user_info.email,
          name: member.user_info.name,
        },
      ];
    });

    this.props.createInvite(deal.id, inviteData);

    this.props.createDealUser({
      deal: deal.id,
      user: profile.id,
      type: 'owner',
    });

    if (this.getPubishable()) {
      fields.memberPublishers &&
        fields.memberPublishers.forEach((member) => {
          if (member.publishers && member.publishers.length) {
            member.publishers.forEach(
              ({ publisherName, publisher_share, society }) => {
                if (publisherName || publisher_share || society) {
                  this.props.createPublisher({
                    deal: deal.id,
                    user: member.user,
                    publisher_name: publisherName,
                    publisher_share: parseFloat(publisher_share, 10) || 0,
                    society: society,
                  });
                }
              }
            );
          }
        });
    }

    this.props.resetCreateWork();
  }

  handlePrev() {
    const { agreement, params } = this.props;

    if (params.prev === 'agreement-terms') {
      if (agreement.type === 'premium') {
        this.props.router.push(
          `/create/agreement-terms/ownership/premium-split`
        );
      } else if (agreement.type === 'workforhire') {
        this.props.router.push(
          `/create/agreement-terms/work-for-hire/work-for-hire`
        );
      } else if (agreement.type === 'producer') {
        this.props.router.push(`/create/agreement-terms/producer/producer`);
      } else {
        this.props.router.push(`/create`);
      }
    } else {
      if (params.prev === 'agreement-ownership-split') {
        this.props.router.push(`/create/agreement-ownership-percentage/split`);
      } else {
        this.props.router.push(`/create/${this.props.params.prev}`);
      }
    }
  }

  renderSplits() {
    const {
      workOwnerships,
      roles,
      ownershipTypes,
      agreement,
      contractBlocks,
      members,
      fields,
    } = this.props;

    if (agreement.type !== 'workforhire' && agreement.type !== 'producer') {
      let licenserIds = [];
      const block = R.find(R.propEq('name', 'Licensing Permissions'))(
        contractBlocks
      );

      if (block && block.options) {
        licenserIds = block.options.licenserIds || [];
      }

      if (workOwnerships) {
        let i = 0;
        const rows = [];

        workOwnerships.forEach(
          ({ user, ownership_type, percentage, role_ids }) => {
            let userName = '';
            const member = getMemberByUserId(user, members);

            if (member && member.user_info) {
              userName = member.user_info.name;

              if (
                member.user_info.use_company_name &&
                member.user_info.company_name
              ) {
                userName += ` (${member.user_info.company_name})`;
              }
            }

            let publishers = [];
            if (this.getPubishable()) {
              const memberPublisher = R.find(R.propEq('user', user))(
                fields.memberPublishers || []
              );
              publishers =
                memberPublisher && memberPublisher.publishers
                  ? memberPublisher.publishers
                  : [];
            }

            rows.push(
              <tr key={i}>
                <td>{userName}</td>
                <td>{getRoleNames(role_ids, roles).join(', ')}</td>
                <td>{getOwnershipTypeName(ownership_type, ownershipTypes)}</td>
                <td>{percentage}%</td>
                {agreement.type === 'premium' ? (
                  <td>{licenserIds.indexOf(user) !== -1 ? 'Yes' : 'No'}</td>
                ) : null}
              </tr>
            );
            i++;

            publishers.forEach(
              ({ publisherName, society, publisher_share }) => {
                if (publisherName || society || publisher_share) {
                  rows.push(
                    <tr key={i}>
                      <td></td>
                      <td></td>
                      <td>
                        <div key={i} className="nowrap">
                          {' '}
                          - {publisherName}({society})
                        </div>
                      </td>
                      <td>
                        <div key={i} className="nowrap">
                          {' '}
                          - Pub Share: {parseFloat(publisher_share, 10) || 0}%
                        </div>
                      </td>
                      {agreement.type === 'premium' ? <td></td> : null}
                    </tr>
                  );
                  i++;
                }
              }
            );
          }
        );

        return (
          <div className="user-status">
            <table>
              <thead>
                <tr>
                  <th>Contributors</th>
                  <th>Role</th>
                  <th>
                    {fields.soundRecordingType === 'revenue'
                      ? 'Copyright Type'
                      : 'Ownership Type'}
                  </th>
                  <th>
                    {fields.soundRecordingType === 'revenue'
                      ? 'Revenue Type'
                      : 'Ownership Split'}
                  </th>
                  {agreement.type === 'premium' ? (
                    <th>Permission to License</th>
                  ) : null}
                </tr>
              </thead>
              <tbody>{rows}</tbody>
            </table>
          </div>
        );
      }
    }
  }

  handleComments = (e) => {
    this.setState({ comments: e.target.value });
  };

  renderMessage() {
    return (
      <div className="comments">
        <div className="subheading">Message to Team</div>
        <textarea
          value={this.state.comments}
          onChange={this.handleComments}
          className="form-control"
        />
      </div>
    );
  }

  renderAgreementTerms() {
    const { agreement, contractBlocks, agreementContractBlocks } = this.props;

    if (agreement && agreement.type === 'split') {
      return null;
    } else if (contractBlocks && agreementContractBlocks) {
      const blocks = [];

      contractBlocks.forEach((block) => {
        if (
          (agreement.type === 'premium' &&
            block['block_type'].includes('premium') === true) ||
          (agreement.type === 'workforhire' &&
            block['block_type'].includes('work_for_hire') === true) ||
          (agreement.type === 'producer' &&
            block['block_type'].includes('producer') === true)
        ) {
          const index = R.findIndex(R.propEq('contract_block', block.id))(
            agreementContractBlocks
          );
          if (index !== -1) {
            block.content = agreementContractBlocks[index].content;
            block.options = JSON.parse(agreementContractBlocks[index].options);
          }
          blocks.push(block);
        }
      });

      return (
        <div className="contract-terms">
          <div className="subheading">Contract Terms</div>
          <div className="note">
            Note: If an attorney has redlined this agreement, the terms below
            may have changed and may not be applicable. Carefully read and
            review your entire agreement before proceeding.
          </div>
          <br />
          <table>
            <tbody>
              {blocks.map((block, i) => {
                if (block.name !== 'Licensing Permissions') {
                  return (
                    <ShortContent
                      key={i}
                      block={block}
                      blocks={blocks}
                      type="review"
                    />
                  );
                } else {
                  return null;
                }
              })}
            </tbody>
          </table>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const { team, agreement, route, status, workStatus, dealStatus } =
      this.props;
    const disabled =
      status === actionTypes.AGREEMENT_CREATE_REQUEST ||
      workStatus === actionTypes.WORK_CREATE_REQUEST ||
      dealStatus === actionTypes.DEAL_CREATE_REQUEST;

    if (route.type === 'create' && (!team || !agreement)) {
      return null;
    } else {
      return (
        <div className="review">
          <Heading text="Send your Agreement" />
          <div className="content">
            <Row>
              <Col sm={4}>
                <Sidebar type="review" agreement={agreement} />
              </Col>
              <Col sm={8}>
                <p className="text-gray">
                  You're almost done! Review your proposed agreement terms below
                  before sending it to your collaborators. Each collaborator
                  will receive a notification and will be able to accept or
                  propose changes.
                </p>
                {this.renderAgreementTerms()}
              </Col>
            </Row>
            <br />
            {this.renderSplits()}
            {this.renderMessage()}
          </div>
          <div className="step-nav">
            <NavButtons direction="back" prev={() => this.handlePrev()} />
            <NavButtons
              direction="end"
              disabled={disabled}
              next={() => this.handleSave()}
            />
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  roles: state.global.roles,
  ownershipTypes: state.global.ownershipTypes,
  profile: state.profile,
  team: state.teams.selectedTeam,
  members: state.users.members,
  workOwnerships: state.workOwnerships.workOwnerships,
  fields: state.create.fields,
  contractBlocks: state.global.contractBlocks,
  agreement: state.agreements.selectedAgreement,
  agreementContractBlocks: state.agreements.contractBlocks,
  status: state.agreements.status,
  deal: state.deals.selectedDeal,
  dealStatus: state.deals.status,
  work: state.works.selectedWork,
  workStatus: state.works.status,
  workTypes: state.global.workTypes,
  subscription: state.payment.subscription,
  invites: state.invites,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
  loadBlockContents: (agreementId) => {
    dispatch(actions.getAgreementContractBlockContents(agreementId));
  },
  saveBlockContent: (block) => {
    dispatch(actions.saveAgreementContractBlockContent(block));
  },
  createAgreement: (agreement) => {
    dispatch(actions.createAgreement(agreement));
  },
  saveAgreement: (agreementId, agreement) => {
    dispatch(actions.updateAgreement(agreementId, agreement));
  },
  createWork: (work) => {
    dispatch(actions.createWork(work));
  },
  resetCreateWork: () => {
    dispatch(actions.resetAttribute());
    dispatch(actions.resetContractBlockContents());
  },
  createDeal: (deal) => {
    dispatch(actions.createDeal(deal));
  },
  createInvite: (dealId, invite) => {
    dispatch(actions.createInvite(dealId, invite));
  },
  createWorkOwnership: (workOwnership) => {
    dispatch(actions.createWorkOwnership(workOwnership));
  },
  createDealUser: (dealUser) => {
    dispatch(actions.createDealUser(dealUser));
  },
  createPublisher: (publisher) => {
    dispatch(actions.createPublisher(publisher));
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignAttribute(field, attribute));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateReview));



// WEBPACK FOOTER //
// src/components/Create/CreateReview.jsx